import { combineReducers, configureStore } from '@reduxjs/toolkit'
import authSlice from '@store/slices/auth.slice'
import playlistSlice from '@store/slices/playlist.slice'
import aiMetaSlice from '@store/slices/aiMeta.slice'
import slotSlice from '@store/slices/aiSlot.slice'
import authorSlice from '@store/slices/author.slice'
import voiceSlice from '@store/slices/voice.slice'
import regionSlice from '@store/slices/region.slice'
import taskSlice from '@store/slices/task.slice'
import narrationSlice from '@store/slices/narration.slice'
import audioSlice from '@store/slices/audio.slice'
import templateSlice from '@store/slices/template.slice'

const rootReducer = combineReducers({
  auth: authSlice,
  playlist: playlistSlice,
  aiMetadata: aiMetaSlice,
  slot: slotSlice,
  author: authorSlice,
  voice: voiceSlice,
  region: regionSlice,
  task: taskSlice,
  narration: narrationSlice,
  audio: audioSlice,
  template: templateSlice,
})

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['audio/downloadAudio/fulfilled', 'persist/PERSIST'], // Ignore this action type
      },
    }),
})

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
